/**
 * 404 Not Found page.
 */

import { Link } from 'react-router-dom';
import { Button } from '@/components/ui';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-slate-50 px-4">
      <div className="text-center">
        {/* 404 Icon */}
        <div className="mb-6">
          <svg
            className="mx-auto h-24 w-24 text-slate-300"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>

        {/* Error Message */}
        <h1 className="text-6xl font-bold text-slate-900">404</h1>
        <h2 className="mt-2 text-xl font-semibold text-slate-700">Page Not Found</h2>
        <p className="mt-4 max-w-md text-slate-500">
          Sorry, we couldn't find the page you're looking for. It might have been moved or
          doesn't exist.
        </p>

        {/* Action Buttons */}
        <div className="mt-8 flex flex-col items-center gap-4 sm:flex-row sm:justify-center">
          <Link to="/">
            <Button variant="primary">Go to Dashboard</Button>
          </Link>
          <Button variant="outline" onClick={() => window.history.back()}>
            Go Back
          </Button>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-16 text-center text-sm text-slate-400">
        <p>Dynatron-AI Portfolio Management</p>
      </div>
    </div>
  );
}
